import React, { Component } from "react";
import { Div, Text, Input, Button, Image } from "atomize";
import InnerHTML from "../../utilities/innerHtml";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { updateActiveCampaignForm } from "../../utilities/helpers";
import SolutionsPagesButton from "../common/SolutionsPagesButtons";

export default class CamaignSuiteHero extends Component {
  render() {
    const { content, form } = this.props;
    return (
      <Div m={{ b: "2.25rem" }} p={{ b: { xs: "8rem", md: "14rem" } }}>
        <Div className="solutions-gradient-hero solutions">
          <WebsiteContainer>
            <CustomContainer>
              <Div textAlign="center" p={{ t: "3.8rem" }}>
                <Text
                  className="hero-text"
                  textSize={{ xs: "title2", md: "display2" }}
                  p={{ x: { xs: "0", md: "10rem" } }}
                  textWeight="700"
                  tag="h1"
                >
                  {content.heading}
                </Text>
                <Text
                  maxW="31rem"
                  m=".7rem auto"
                  textSize={{ xs: "17px", md: "paragraph" }}
                  style={{ lineHeight: "30px" }}
                >
                  {content.text}
                </Text>
                <Div maxW="24.2rem" m="1.7rem auto">
                  <SolutionsPagesButton
                    bgColor="primary"
                    hoverBgPrimary="#FFCB6F"
                    textColor="black"
                  />
                  {/* {typeof window !== "undefined" && (
                    <InnerHTML html={updateActiveCampaignForm(form)} />
                  )} */}
                  {/* <Input
                    placeholder="youremail@email.com"
                    rounded="xs"
                    fontFamily="secondary"
                    h="3.125rem"
                    textSize={{ xs: "caption2", md: "14px" }}
                    border="none"
                    suffix={
                      <Button
                        pos="absolute"
                        onClick={() => console.log("clicked")}
                        bg="primary"
                        hoverBg="primary700"
                        textColor="black"
                        top="0"
                        right="0"
                        h="3.125rem"
                        textSize={{ xs: "caption2", md: "14px" }}
                        p={{ x: { xs: "1rem", md: "1.9rem" } }}
                        textWeight="700"
                        fontFamily="secondary"
                        rounded={{ r: "xs" }}
                      >
                        {content.button}
                      </Button>
                    }
                  /> */}
                </Div>
              </Div>
              <Div
                d={{ xs: "none", md: "block" }}
                textAlign="center"
                m={{ t: "5rem" }}
                p={{ x: "2rem" }}
              >
                <ImageLink link="">
                  <Image
                    alt={content.altPC && content.altPC}
                    src={content.imgPC}
                    m={{ l: "-1rem", b: "-14rem" }}
                  />
                </ImageLink>
              </Div>
            </CustomContainer>
            <Div
              d={{ xs: "block", md: "none" }}
              textAlign="center"
              m={{ t: "4.375rem" }}
            >
              <ImageLink link="">
                <Image
                  alt={content.altMobile && content.altMobile}
                  src={content.imgMobile}
                  m={{ b: "-5rem" }}
                />
              </ImageLink>
            </Div>
          </WebsiteContainer>
        </Div>
      </Div>
    );
  }
}
